/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRolesQuery } from '../../models/get-roles-query';
import { GetRolesQueryResult } from '../../models/get-roles-query-result';

export interface GetRolesPost$Params {
      body?: GetRolesQuery
}

export function getRolesPost(http: HttpClient, rootUrl: string, params?: GetRolesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRolesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, getRolesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRolesQueryResult>;
    })
  );
}

getRolesPost.PATH = '/GetRoles';
